export class ImportDataSet {
    UserID: number;
    FileName: string;
    Headers: string[];
    ImportID: number;
    DataSets: string[];
    Is_ALM_Import: boolean;
  }
